import { render, staticRenderFns } from "./Returnly.vue?vue&type=template&id=47bf3d78"
import script from "./Returnly.vue?vue&type=script&lang=js"
export * from "./Returnly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports